import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin, of, shareReplay } from 'rxjs';
import { RequestService } from '../../../_services/request/request.service';
import {
  CoverageType,
  LimitType,
  StackType,
  UIUMSelectionType,
  GaragingSelectionType,
} from '../../../config/constants';
import { ArizonaComponent } from '../../../state-disclosures/uimui/arizona/arizona.component';
import { ColoradoComponent } from '../../../state-disclosures/uimui/colorado/colorado.component';
import { DelawareComponent } from '../../../state-disclosures/uimui/delaware/delaware.component';
import { FloridaComponent } from '../../../state-disclosures/uimui/florida/florida.component';
import { IdahoComponent } from '../../../state-disclosures/uimui/idaho/idaho.component';
import { MaineComponent } from '../../../state-disclosures/uimui/maine/maine.component';
import { MarylandComponent } from '../../../state-disclosures/uimui/maryland/maryland.component';
import { MichiganComponent } from '../../../state-disclosures/uimui/michigan/michigan.component';
import { MissouriComponent } from '../../../state-disclosures/uimui/missouri/missouri.component';
import { MontanaComponent } from '../../../state-disclosures/uimui/montana/montana.component';
import { NebraskaComponent } from '../../../state-disclosures/uimui/nebraska/nebraska.component';
import { NevadaComponent } from '../../../state-disclosures/uimui/nevada/nevada.component';
import { NewHampshireComponent } from '../../../state-disclosures/uimui/new-hampshire/new-hampshire.component';
import { NewJerseyComponent } from '../../../state-disclosures/uimui/new-jersey/new-jersey.component';
import { NewYorkComponent } from '../../../state-disclosures/uimui/new-york/new-york.component';
import { NorthDakotaComponent } from '../../../state-disclosures/uimui/north-dakota/north-dakota.component';
import { OklahomaComponent } from '../../../state-disclosures/uimui/oklahoma/oklahoma.component';
import { SouthDakotaComponent } from '../../../state-disclosures/uimui/south-dakota/south-dakota.component';
import { TexasComponent } from '../../../state-disclosures/uimui/texas/texas.component';
import { VermontComponent } from '../../../state-disclosures/uimui/vermont/vermont.component';
import { WashingtonComponent } from '../../../state-disclosures/uimui/washington/washington.component';
import { WisconsinComponent } from '../../../state-disclosures/uimui/wisconsin/wisconsin.component';
import { WyomingComponent } from '../../../state-disclosures/uimui/wyoming/wyoming.component';
import { Control } from '../alabama/alabama-model';
import { AlabamaComponent } from '../alabama/alabama.component';
import { AlaskaComponent } from '../alaska/alaska.component';
import { ArkansasComponent } from '../arkansas/arkansas.component';
import { CaliforniaComponent } from '../california/california.component';
import { ConnecticutComponent } from '../connecticut/connecticut.component';
import { DistrictOfColumbiaComponent } from '../district-of-columbia/district-of-columbia.component';
import { GeorgiaComponent } from '../georgia/georgia.component';
import { HawaiiComponent } from '../Hawaii/hawaii.component';
import { IndianaComponent } from '../indiana/indiana.component';
import { IowaComponent } from '../iowa/iowa.component';
import { KansasComponent } from '../kansas/kansas.component';
import { KentuckyComponent } from '../kentucky/kentucky.component';
import { LouisianaComponent } from '../louisiana/louisiana.component';
import { MinnesotaComponent } from '../Minnesota/minnesota.component';
import { NewMexicoComponent } from '../new-mexico/new-mexico.component';
import { NorthCarolinaComponent } from '../north-carolina/north-carolina.component';
import { TennesseeComponent } from '../tennessee/tennessee.component';
import { VirginiaComponent } from '../virginia/virginia.component';
import { OregonComponent } from '../oregon/oregon.component';
import { SouthCarolinaComponent } from '../south-carolina/south-carolina.component';
import { IllinoisComponent } from '../illinois/illinois.component';
import { PennsylvaniaComponent } from '../pennsylvania/pennsylvania.component';
import { MassachusettsComponent } from '../massachusetts/massachusetts.component';
import { WestVirginiaComponent } from '../west-virginia/west-virginia.component';
import { RhodeIslandComponent } from '../rhode-island/rhode-island.component';
import { OhioComponent } from '../ohio/ohio.component';

import { MississippiComponent } from '../mississippi/mississippi.component';
import { UtahComponent } from '../utah/utah.component';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class UimuiBaseRulesService {
  states: {
    state: string;
    stateComponent: any;
    formGroup?: FormGroup;
    defaultQuery?: string;
  }[] = [];
  savedBaseRules = {};
  selectionTypeKey = this.getEnumKeyByValue(
    UIUMSelectionType,
    UIUMSelectionType.RejectWhenPossible,
  );
  limitTypeKey = this.getEnumKeyByValue(
    LimitType,
    LimitType.CombinedSingleLimit,
  );
  coverageTypeKey = this.getEnumKeyByValue(
    CoverageType,
    CoverageType.BodilyInjuryWithMandatoryPropertyDamage,
  );
  stackTypeKey = this.getEnumKeyByValue(StackType, StackType.Stacked);
  garagingSelectionKey = this.getEnumKeyByValue(
    GaragingSelectionType,
    GaragingSelectionType.GaragingStateSelection,
  );
  isContinueButtonClicked = false;
  canNavigateFromSummary: () => boolean = () => true;
  liabilityLimitRI: string = '';
  dataDump = [];
  pdfDataDump = {};
  pdfSummaryDataDump = {};
  constructor(
    private httpClient: HttpClient,
    private requestService: RequestService,
  ) {
    this.liabilityLimitRI = this.requestService
      .getLiabilityLimitForState('rhode-island')
      .split('.')[0];

    this.initializeStates();
  }
  private initializeStates() {
    this.states = [
      {
        state: 'alabama',
        stateComponent: AlabamaComponent,
        defaultQuery: 'RejectWhenPossible_CombinedSingleLimit',
      },
      {
        state: 'alaska',
        stateComponent: AlaskaComponent,
        defaultQuery:
          'RejectWhenPossible_CombinedSingleLimit_BodilyInjuryWithMandatoryPropertyDamage',
      },
      {
        state: 'arizona',
        stateComponent: ArizonaComponent,
        defaultQuery: 'RejectWhenPossible_CombinedSingleLimit',
      },
      {
        state: 'arkansas',
        stateComponent: ArkansasComponent,
        defaultQuery:
          'RejectWhenPossible_CombinedSingleLimit_BodilyInjuryWithMandatoryPropertyDamage',
      },
      {
        state: 'california',
        stateComponent: CaliforniaComponent,
        defaultQuery:
          'RejectWhenPossible_CombinedSingleLimit_BodilyInjuryWithMandatoryPropertyDamage',
      },
      {
        state: 'colorado',
        stateComponent: ColoradoComponent,
        defaultQuery:
          'RejectWhenPossible_CombinedSingleLimit_BodilyInjuryWithMandatoryPropertyDamage',
      },
      {
        state: 'connecticut',
        stateComponent: ConnecticutComponent,
        defaultQuery: 'NonGarage',
      },
      {
        state: 'delaware',
        stateComponent: DelawareComponent,
        defaultQuery:
          'RejectWhenPossible_CombinedSingleLimit_BodilyInjuryWithMandatoryPropertyDamage',
      },
      {
        state: 'district-of-columbia',
        stateComponent: DistrictOfColumbiaComponent,
        defaultQuery: 'NonGarage',
      },
      {
        state: 'florida',
        stateComponent: FloridaComponent,
        defaultQuery: 'RejectWhenPossible_CombinedSingleLimit',
      },
      {
        state: 'georgia',
        stateComponent: GeorgiaComponent,
        defaultQuery:
          'RejectWhenPossible_CombinedSingleLimit_BodilyInjuryWithMandatoryPropertyDamage',
      },
      {
        state: 'hawaii',
        stateComponent: HawaiiComponent,
        defaultQuery: 'RejectWhenPossible_CombinedSingleLimit',
      },
      {
        state: 'idaho',
        stateComponent: IdahoComponent,
        defaultQuery: 'RejectWhenPossible_CombinedSingleLimit',
      },
      {
        state: 'illinois',
        stateComponent: IllinoisComponent,
        defaultQuery:
          'RejectWhenPossible_CombinedSingleLimit_BodilyInjuryWithMandatoryPropertyDamage',
      },
      {
        state: 'indiana',
        stateComponent: IndianaComponent,
        defaultQuery:
          'RejectWhenPossible_CombinedSingleLimit_BodilyInjuryWithMandatoryPropertyDamage',
      },
      {
        state: 'iowa',
        stateComponent: IowaComponent,
        defaultQuery: 'RejectWhenPossible_CombinedSingleLimit',
      },
      {
        state: 'kansas',
        stateComponent: KansasComponent,
        defaultQuery: 'RejectWhenPossible_CombinedSingleLimit',
      },
      {
        state: 'kentucky',
        stateComponent: KentuckyComponent,
        defaultQuery: 'RejectWhenPossible_CombinedSingleLimit',
      },
      {
        state: 'louisiana',
        stateComponent: LouisianaComponent,
        defaultQuery: 'RejectWhenPossible_CombinedSingleLimit',
      },
      {
        state: 'maine',
        stateComponent: MaineComponent,
        defaultQuery: 'RejectWhenPossible_CombinedSingleLimit',
      },
      {
        state: 'maryland',
        stateComponent: MarylandComponent,
        defaultQuery: 'StateMinimum_CombinedSingleLimit',
      },
      {
        state: 'massachusetts',
        stateComponent: MassachusettsComponent,
        defaultQuery: 'RejectWhenPossible_CombinedSingleLimit',
      },
      {
        state: 'michigan',
        stateComponent: MichiganComponent,
        defaultQuery: 'RejectWhenPossible_CombinedSingleLimit',
      },
      {
        state: 'minnesota',
        stateComponent: MinnesotaComponent,
        defaultQuery: 'RejectWhenPossible_CombinedSingleLimit',
      },
      {
        state: 'mississippi',
        stateComponent: MississippiComponent,
        defaultQuery:
          'RejectWhenPossible_CombinedSingleLimit_BodilyInjuryWithMandatoryPropertyDamage',
      },
      {
        state: 'missouri',
        stateComponent: MissouriComponent,
        defaultQuery: 'NonGarage',
      },
      {
        state: 'montana',
        stateComponent: MontanaComponent,
        defaultQuery: 'RejectWhenPossible_CombinedSingleLimit',
      },
      {
        state: 'nebraska',
        stateComponent: NebraskaComponent,
        defaultQuery: 'RejectWhenPossible_CombinedSingleLimit',
      },
      {
        state: 'nevada',
        stateComponent: NevadaComponent,
        defaultQuery: 'RejectWhenPossible_CombinedSingleLimit',
      },
      {
        state: 'new-hampshire',
        stateComponent: NewHampshireComponent,
        defaultQuery:
          'RejectWhenPossible_CombinedSingleLimit_BodilyInjuryWithMandatoryPropertyDamage',
      },
      {
        state: 'new-jersey',
        stateComponent: NewJerseyComponent,
        defaultQuery:
          'RejectWhenPossible_CombinedSingleLimit_BodilyInjuryWithMandatoryPropertyDamage',
      },
      {
        state: 'new-mexico',
        stateComponent: NewMexicoComponent,
        defaultQuery: 'RejectWhenPossible_CombinedSingleLimit',
      },
      {
        state: 'new-york',
        stateComponent: NewYorkComponent,
        defaultQuery: 'RejectWhenPossible_CombinedSingleLimit',
      },
      {
        state: 'north-carolina',
        stateComponent: NorthCarolinaComponent,
        defaultQuery:
          'StateMinimum_CombinedSingleLimit_BodilyInjuryWithMandatoryPropertyDamage',
      },
      {
        state: 'north-dakota',
        stateComponent: NorthDakotaComponent,
        defaultQuery: 'StateMinimum_CombinedSingleLimit',
      },
      {
        state: 'ohio',
        stateComponent: OhioComponent,
        defaultQuery:
          'RejectWhenPossible_CombinedSingleLimit_BodilyInjuryWithMandatoryPropertyDamage',
      },
      {
        state: 'oklahoma',
        stateComponent: OklahomaComponent,
        defaultQuery: 'RejectWhenPossible_CombinedSingleLimit',
      },
      {
        state: 'oregon',
        stateComponent: OregonComponent,
        defaultQuery: 'NonGarage',
      },
      {
        state: 'pennsylvania',
        stateComponent: PennsylvaniaComponent,
        defaultQuery: 'RejectWhenPossible_CombinedSingleLimit',
      },
      {
        state: 'rhode-island',
        stateComponent: RhodeIslandComponent,
        defaultQuery:
          this.getNumberFromString(this.liabilityLimitRI) > 75000
            ? 'Above_75k_Reject_Reject_Csl'
            : 'Below_75k_Reject',
      },
      {
        state: 'south-carolina',
        stateComponent: SouthCarolinaComponent,
        defaultQuery: 'RejectWhenPossible_CombinedSingleLimit',
      },
      {
        state: 'south-dakota',
        stateComponent: SouthDakotaComponent,
        defaultQuery: 'RejectWhenPossible_CombinedSingleLimit',
      },
      {
        state: 'tennessee',
        stateComponent: TennesseeComponent,
        defaultQuery:
          'RejectWhenPossible_CombinedSingleLimit_BodilyInjuryWithMandatoryPropertyDamage',
      },
      {
        state: 'texas',
        stateComponent: TexasComponent,
        defaultQuery:
          'RejectWhenPossible_CombinedSingleLimit_BodilyInjuryWithMandatoryPropertyDamage',
      },
      {
        state: 'utah',
        stateComponent: UtahComponent,
        defaultQuery: 'NonGarage',
      },
      {
        state: 'vermont',
        stateComponent: VermontComponent,
        defaultQuery: 'RejectWhenPossible_CombinedSingleLimit',
      },
      {
        state: 'virginia',
        stateComponent: VirginiaComponent,
        defaultQuery: 'NonGarage',
      },
      {
        state: 'washington',
        stateComponent: WashingtonComponent,
        defaultQuery:
          'RejectWhenPossible_CombinedSingleLimit_BodilyInjuryWithMandatoryPropertyDamage',
      },
      {
        state: 'west-virginia',
        stateComponent: WestVirginiaComponent,
        defaultQuery: 'RejectWhenPossible_CombinedSingleLimit',
      },
      {
        state: 'wisconsin',
        stateComponent: WisconsinComponent,
        defaultQuery: 'RejectWhenPossible_CombinedSingleLimit',
      },
      {
        state: 'wyoming',
        stateComponent: WyomingComponent,
        defaultQuery: 'RejectWhenPossible_CombinedSingleLimit',
      },
    ];
  }
  private saveDataSubject = new Subject<{ saveDataDump: boolean }>();
  public saveData$ = this.saveDataSubject.asObservable();
  public isPlayground: boolean = false;
  public triggerDataSave(): void {
    this.saveDataSubject.next({ saveDataDump: true });
  }

  private rulesCache = new Map<string, any>();
  getApplicableStates() {
    let coveredStates = this.requestService.getCoveredStates();
    coveredStates = coveredStates.map((state: string) =>
      state.replace(/ /g, '-'),
    );
    let applicableStates = this.states.filter((stateObj) =>
      coveredStates.includes(stateObj.state),
    );
    return applicableStates;
  }

  getNonGarageStates() {
    // Return empty array if AllStateSelection, no selection
    if (
      this.garagingSelectionKey === 'AllStateSelection' ||
      !this.garagingSelectionKey ||
      this.garagingSelectionKey !== 'GaragingStateSelection'
    ) {
      return [];
    }
    // When GaragingStateSelection is chosen, calculate nonGarageStates = CoveredStates - GarageStates
    let coveredStates = this.requestService.getCoveredStates();
    coveredStates = coveredStates.map((state: string) =>
      state.replace(/ /g, '-'),
    );

    let garageStates = this.requestService.getGarageStates();
    garageStates = garageStates.map((state: string) =>
      state.replace(/ /g, '-'),
    );

    // Return empty array if no garage states exist
    if (!garageStates || garageStates.length === 0) {
      return [];
    }

    // Filter out garage states from covered states to get non-garage states
    const nonGarageStates = coveredStates.filter(
      (state) =>
        !garageStates.includes(state.toLowerCase().replace(/\s+/g, '-')),
    );

    return nonGarageStates;
  }

  getAllRules(state: string) {
    if (this.rulesCache.has(state)) {
      return this.rulesCache.get(state);
    }

    const textValues = this.httpClient.get<any>(
      `assets/data/uim-ui/states/${state}/${state}-text-values.json`,
    );
    const dynamicRules = this.httpClient.get<any>(
      `assets/data/uim-ui/states/${state}/${state}-dynamic-rule.json`,
    );
    const controls = this.httpClient.get<any>(
      `assets/data/uim-ui/states/${state}/${state}-controls.json`,
    );
    const baseRules = this.httpClient.get<any[]>(
      `assets/data/uim-ui/states/${state}/${state}-base-rule.json`,
    );

    const rules$ = forkJoin({
      baseRules: baseRules,
      controls: controls,
      dynamicRules: dynamicRules,
      textValues: textValues,
      state: of(state),
    }).pipe(shareReplay(1));

    this.rulesCache.set(state, rules$);
    return rules$;
  }
  // Helper function
  getEnumKeyByValue(enumObj: any, value: string): string | undefined {
    return Object.keys(enumObj).find((key) => enumObj[key] === value);
  }
  getRuleBySelectionId(baseRules: any[], queryStringBuilder: string) {
    let queryString = '';
    if (queryStringBuilder === undefined) {
      queryString = this.getQueryString(baseRules);
    } else {
      queryString = queryStringBuilder;
    }
    return baseRules.find((rule) => rule.selectionId === queryString);
  }

  getNumberFromString(value: string): number {
    const splitArray = value.split('/');
    const numericString =
      splitArray.length === 2
        ? splitArray[1].replace(/[^0-9.-]+/g, '')
        : value.replace(/[^0-9.-]+/g, '');
    return parseFloat(numericString);
  }

  getQueryString(res: any): string {
    const baseQueryCount = res[0].selectionId.split('_').length;
    switch (baseQueryCount) {
      case 2:
        return `${this.selectionTypeKey}_${this.limitTypeKey}`;
        break;
      case 3:
        return `${this.selectionTypeKey}_${this.limitTypeKey}_${this.coverageTypeKey}`;
        break;
      case 4:
        return `${this.selectionTypeKey}_${this.limitTypeKey}_${this.coverageTypeKey}_${this.stackTypeKey}`;
        break;
      default:
        break;
    }
  }
  getValueOfFormControls(value: any) {
    if ('selectedIndex' in value) {
      return value['value'];
    } else if ('isSelected' in value) {
      return value['name'];
    } else {
      ('');
    }
  }

  initialPDFDataDumpProp(controls: Control[], state: string) {
    let pdfObj = {};
    controls.forEach((control) => {
      if (control.formControlName.toLocaleLowerCase().includes('_radio')) {
        control.option.forEach((option) => {
          pdfObj[option.baseRuleKey.toLocaleLowerCase()] = false;
        });
      } else if (
        control.baseRuleKey.toLocaleLowerCase().includes('_dropdown')
      ) {
        control.data.forEach((data) => {
          pdfObj[
            control.baseRuleKey.toLocaleLowerCase().split('dropdown')[0] +
              this.stripDropDownValue(data.name)
          ] = false;
        });
      } else if (control.baseRuleKey.toLocaleLowerCase().includes('_input')) {
        pdfObj[control.baseRuleKey.toLocaleLowerCase()] = '';
      }
    });
    //hack to avoid selection page
    // this.pdfDataDump[state] = {
    //   ...pdfObj,
    // };
    if ('data' in this.dataDump) {
      this.pdfDataDump[state] = {
        ...pdfObj,
        ...{
          namedInsured: this.requestService.getNamedInsured(),
          initials: this.requestService.getInitials(),
          policyNumber: this.requestService.getPolicyNumberForState(state),
          liabilityLimit: this.requestService.getLiabilityLimitForState(state),
          removeForm: false,
          policyDurationMonths: this.requestService.getPolicyDurationInMonths(),
        },
      };
    }
  }

  getPdfDataDumpPropForOutstandingPage(state: string, formData: any) {
    this.setReadOnlyDynamicRulesForPDFDump(state);
    let pdfObj = {};
    for (const [key, value] of Object.entries(formData)) {
      if ((value as string).toLowerCase().includes('_radio')) {
        pdfObj = {
          ...pdfObj,
          ...{ [(value as string).toLocaleLowerCase()]: true },
        };
      }
      if (key.toLocaleLowerCase().includes('_dropdown')) {
        pdfObj = {
          ...pdfObj,
          ...{
            [key.toLocaleLowerCase().split('dropdown')[0] +
            this.stripDropDownValue(value)]: true,
          },
        };
      }
      if (key.toLocaleLowerCase().includes('_input')) {
        pdfObj = {
          ...pdfObj,
          ...{ [key.toLocaleLowerCase()]: value },
        };
      }
      if (key.toLocaleLowerCase().includes('forvalue_')) {
        pdfObj = {
          ...pdfObj,
          ...{ [key.toLocaleLowerCase()]: value },
        };
      }
    }

    // Only update if there's existing data or new data to add
    if (this.pdfDataDump[state] || Object.keys(pdfObj).length > 0) {
      this.pdfDataDump[state] = {
        ...this.pdfDataDump[state],
        ...pdfObj,
      };
    }
  }
  setReadOnlyDynamicRulesForPDFDump(state: string) {
    const pdfObj = {};
    Array.from(document.querySelectorAll('[id]'))
      .filter((ele) => ele.id.includes('-pdffield-' + state))
      .map((ele) => ele.id.split('-pdffield-' + state)[0])
      .forEach((id) => {
        pdfObj[id] = true;
      });

    // Only update if there's existing data or new data to add
    if (this.pdfDataDump[state] || Object.keys(pdfObj).length > 0) {
      this.pdfDataDump[state] = {
        ...this.pdfDataDump[state],
        ...pdfObj,
      };
    }
  }

  isStatePageEmpty(containerElement?: Element): boolean {
    // Use specific container or document to check if all <app-state> components are empty
    const searchRoot = containerElement || document;
    const stateSelectors = this.states.map(
      (s) => `app-${s.state.replace(/_/g, '-').replace(/ /g, '-')}`,
    );
    for (const selector of stateSelectors) {
      const elements = Array.from(searchRoot.querySelectorAll(selector));
      for (const el of elements) {
        if (el.hasChildNodes() && el.childNodes.length > 0) {
          if (el.childNodes.length > 2) {
            return false;
          }
        }
      }
    }
    return true;
  }

  private stripDropDownValue(value: unknown) {
    let str = (value as string)
      .replaceAll('$', '')
      .replace(/,000,000/g, 'M')
      .replace(/,000/g, 'k')
      .replace(/ /g, '_')
      .replaceAll('/', '_')
      .replaceAll(',', '');

    // Enhance: convert 1500k to 1_5M, 2500k to 2_5M, etc. anywhere in the string
    str = str.replace(/(\d{4,})k/g, (match, p1) => {
      const num = parseInt(p1, 10);
      const whole = Math.floor(num / 1000);
      const decimal = num % 1000 ? Math.round((num % 1000) / 100) : 0;
      return decimal ? `${whole}_${decimal}M` : `${whole}M`;
    });
    return str;
  }

  getPdfDataDumpPropForSummaryPage(baseRules: any, state: string) {
    // Temporary fix for liability limit summary page break
    if (!baseRules) return;

    let pdfObj = {};
    if (!baseRules.hasOutstanding) {
      for (const [key, value] of Object.entries(baseRules)) {
        if (key.toLowerCase().includes('_radio') && value === 'Yes') {
          pdfObj = { ...pdfObj, ...{ [key.toLocaleLowerCase()]: true } };
        } else if (key.toLocaleLowerCase().includes('_dropdown')) {
          if (
            this.pdfDataDump &&
            state in this.pdfDataDump &&
            this.pdfDataDump[state] &&
            Object.keys(this.pdfDataDump[state]).length > 0
          ) {
            if (value !== 'hide' && value !== 'form') {
              pdfObj[
                Object.keys(this.pdfDataDump[state]).find((obj) =>
                  obj
                    .toLocaleLowerCase()
                    .includes(key.toLocaleLowerCase().split('_dropdown')[0]),
                )
              ] = true;
            }
          }
        }
      }
      this.pdfDataDump[state] = {
        ...this.pdfDataDump[state],
        ...pdfObj,
      };
      this.pdfSummaryDataDump = { ...this.pdfDataDump };
    }
  }
}
